export function getEventTypeClass(type: string): string {
  if (type === 'tool_start') return 'tool-start'
  if (type === 'tool_end') return 'tool-end'
  if (type === 'tool_error') return 'tool-error'
  if (type === 'tool_warning') return 'tool-warning'
  return ''
}

export function getToolName(event: unknown): string {
  const e = event as { data?: { toolName?: string } }
  return e?.data?.toolName || 'Event'
}

export function getTruncatedResponse(event: unknown): string {
  const e = event as any
  if (e?.type === 'tool_start') return `Args: ${JSON.stringify(e?.data?.args || {})}`
  if (e?.type === 'tool_end' && e?.data?.result?.content) {
    const content = e.data.result.content
    if (Array.isArray(content) && content.length > 0 && typeof content[0]?.text !== 'undefined') {
      return typeof content[0].text === 'string' ? content[0].text : JSON.stringify(content[0].text)
    }
    return JSON.stringify(content)
  }
  if (e?.type === 'tool_error') return `Error: ${e?.data?.error?.message || 'Unknown error'}`
  if (e?.type === 'tool_warning') return e?.data?.warning || e?.message || 'Warning'
  if (e?.type === 'llm_start') {
    const label = 'LLM generation started'
    if (e?.data?.time) {
      const d = new Date(e.data.time)
      const ts = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
      return `${label} - ${ts}`
    }
    return label
  }
  return e?.message || ''
}
